import { useSettings } from "@/lib/settings";
import { Phone } from "lucide-react";

export default function FloatingCallButton() {
  const { settings } = useSettings();
  return (
    <a
      href={`tel:${settings.phone}`}
      data-testid="floating-call-btn"
      className="fixed left-4 bottom-4 md:left-6 md:bottom-6 z-50 bg-[color:var(--color-accent)] hover:bg-[color:var(--color-accent-hover)] text-white shadow-xl rounded-full px-4 py-3 flex items-center gap-2 transition transform hover:-translate-y-0.5"
    >
      <Phone className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-medium">Need Help? Call {settings.phone}</span>
      <span className="sm:hidden text-sm font-medium">Call us</span>
    </a>
  );
}
